import { type ObjectWithCreatedAt } from '@/lib/types';

const reverseSortByCreatedAt = (
  a: ObjectWithCreatedAt,
  b: ObjectWithCreatedAt,
): number => {
  return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
};

export default reverseSortByCreatedAt;
